module.exports = __webpack_public_path__ + "static/media/values.1b15c95b.png";